import Navaparkf1 from '../../../Media/Fasilitas BSD/Navapark/Navapark (1).webp'
import Navaparkf2 from '../../../Media/Fasilitas BSD/Navapark/Navapark (2).webp'
import Navaparkf3 from '../../../Media/Fasilitas BSD/Navapark/Navapark (3).webp'
import Navaparkf4 from '../../../Media/Fasilitas BSD/Navapark/Navapark (4).webp'
import Navaparkf5 from '../../../Media/Fasilitas BSD/Navapark/Navapark (5).webp'
import Navaparkf6 from '../../../Media/Fasilitas BSD/Navapark/Navapark (6).webp'
import Navaparkf7 from '../../../Media/Fasilitas BSD/Navapark/Navapark (7).webp'
import Navaparkf8 from '../../../Media/Fasilitas BSD/Navapark/Navapark (8).webp'
import Navaparkf9 from '../../../Media/Fasilitas BSD/Navapark/Navapark (9).webp'
import Navaparkf10 from '../../../Media/Fasilitas BSD/Navapark/Navapark (10).webp'
import Navaparkf11 from '../../../Media/Fasilitas BSD/Navapark/Navapark (11).webp'




const Navaparkfimages =[
Navaparkf1,Navaparkf2,Navaparkf3,Navaparkf4,Navaparkf5,Navaparkf6,Navaparkf7,Navaparkf8,Navaparkf9,Navaparkf10,Navaparkf11
]

export default Navaparkfimages;